// CRM-not-marketing principle (SESSION_MEMORY #1):
// Busy NEVER sends texts. We hand off to the user's SMS app via sms: URL.
// Every text-the-client code path in this app must end here.

export function buildSmsUrl(phone: string, body?: string): string {
  const cleanPhone = phone.replace(/[^\d+]/g, '');
  // iOS uses `sms:&body=`, Android uses `sms:?body=`. The `sms:NUMBER?body=...` form
  // works on both. window.location.href = ... triggers the OS handler.
  const params = body ? `?body=${encodeURIComponent(body)}` : '';
  return `sms:${cleanPhone}${params}`;
}

export function openSms(phone: string, body?: string): void {
  window.location.href = buildSmsUrl(phone, body);
}
